import skizz from '../core/index'

import post from './post'
import get from './get'
import json from './json'

skizz.post = post
skizz.get = get
skizz.json = json
